import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import {AccessLevelActions, AccessLevelStore} from '../types';

const initialState: Omit<AccessLevelStore, keyof AccessLevelActions> = {
    accessLevels: [],
    activeAccessLevel: null,
    permissions: [],
    selectedPermissions: [],
    searchTerm: '',
    actionMode: 'view',
    isModalOpen: false,
    isLoading: false,
    error: null,
};

export const useAccessLevelStore = create<AccessLevelStore>()(
    devtools(
        (set) => ({
            ...initialState,

            setAccessLevels: (accessLevels) =>
                set({ accessLevels }),

            setActiveAccessLevel: (accessLevel) =>
                set({ activeAccessLevel: accessLevel }),

            setPermissions: (permissions) =>
                set({ permissions }),

            setSelectedPermissions: (permissions) =>
                set({ selectedPermissions: permissions }),

            setSearchTerm: (term) =>
                set({ searchTerm: term }),

            setActionMode: (mode) =>
                set({ actionMode: mode }),

            setModalOpen: (isOpen) =>
                set({ isModalOpen: isOpen }),

            resetState: () =>
                set(initialState),
        }),
        { name: 'AccessLevelStore' }
    )
);
